//DISCOUNT TYPE
export enum PromoDiscountType {
    FIXED = 0,
    PERCENTAGE = 1

}